import { parseLocalDateTime } from "@/common/utils";
import { RawServicePointLastTransaction, RawServicePointLastTransactions } from "@/entities";
import { LocalDateTime } from "@js-joda/core";

function parseTransactionDate(value: string | undefined | null): LocalDateTime | undefined {
  if (value == null || value === undefined) return undefined;
  return parseLocalDateTime(value);
}

export class ServicePointLastTransaction {
  readonly total: number;
  readonly accreditationDate: LocalDateTime | undefined;
  readonly currency: string;
  readonly isEarlyValue: boolean;
  readonly servicePointName: string;
  readonly tellerName: string;
  readonly transactionDate: LocalDateTime | undefined;
  readonly transactionType: string;
  constructor(data: RawServicePointLastTransaction) {
    this.total = Number(data.total);
    this.accreditationDate = parseTransactionDate(
      data.accreditationDate === undefined ? undefined : data.accreditationDate
    );
    this.currency = data.currency;
    this.isEarlyValue = data.isEarlyValue ?? data.earlyValue ?? false;
    this.servicePointName = data.servicePointName;
    this.tellerName = data.tellerName;
    this.transactionDate = parseTransactionDate(data.transactionDate);
    this.transactionType = data.transactionType;
  }
}

export class ServicePointLastTransactions {
  readonly servicePointLastTransactions: ServicePointLastTransaction[];
  constructor(data: RawServicePointLastTransactions) {
    const servicePointLastTransactions: ServicePointLastTransaction[] = [];
    const rawList = normalizeToGroupsArray(data);
    rawList.forEach((group) =>
      (group.transactions ?? []).forEach((rawData) => servicePointLastTransactions.push(new ServicePointLastTransaction(rawData)))
    );
    this.servicePointLastTransactions = servicePointLastTransactions;
  }
}

function normalizeToGroupsArray(
  data: RawServicePointLastTransactions
): Array<{ transactions: RawServicePointLastTransaction[] }> {
  if (Array.isArray(data)) return data;
  const d = data as unknown as Record<string, unknown>;
  if (d && Array.isArray(d.transactions))
    return [{ transactions: d.transactions as RawServicePointLastTransaction[] }];
  if (d && Array.isArray(d.content)) return d.content as Array<{ transactions: RawServicePointLastTransaction[] }>;
  return [];
}
